import { useState, useCallback } from "react";
import { Grid, Box, Alert } from "@mui/material";
import { Clear, CheckCircle } from "@mui/icons-material";
import { useAuthentication } from "hooks";
import { FORGOT_PASSWORD_ERROR_MESSAGES } from "constants";
import { BasePage, LoadingButton, LinkButton, EmailInput } from "components";

export function ForgotPasswordPage() {
    const { isButtonLoading, passwordReset } = useAuthentication();

    const [email, setEmail] = useState("");
    const [submitError, setSubmitError] = useState("");
    const [submitSuccess, setSubmitSuccess] = useState("");
    const [emailValid, setEmailValid] = useState(false);

    const handleEmailChange = (email) => {
        if (submitError) setSubmitError("");
        if (submitSuccess) setSubmitSuccess("");
        setEmail(email);
    };

    const handleEmailValidation = useCallback((isValid) => {
        setEmailValid(isValid);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const emailTrimmed = email.trim();
        if (!emailTrimmed) return;

        try {
            setSubmitError("");
            setSubmitSuccess("");

            await passwordReset(emailTrimmed);

            setSubmitSuccess(
                "If an account exists for this email, a reset link has been sent."
            );
        } catch (err) {
            console.error("Password reset error:", err);
            const message =
                (err && err.code && FORGOT_PASSWORD_ERROR_MESSAGES[err.code]) ||
                "We couldn't send the reset email. Please check the address and try again.";
            setSubmitError(message);
        }
    };

    const isFormValid = emailValid;

    return (
        <BasePage title="Forgot password">
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <EmailInput
                            value={email}
                            onChange={handleEmailChange}
                            onValidationChange={handleEmailValidation}
                        />
                    </Grid>

                    {submitError && (
                        <Grid size={12}>
                            <Alert icon={<Clear fontSize="inherit" />} severity="error">
                                {submitError}
                            </Alert>
                        </Grid>
                    )}

                    {submitSuccess && (
                        <Grid size={12}>
                            <Alert icon={<CheckCircle fontSize="inherit" />} severity="success">
                                {submitSuccess}
                            </Alert>
                        </Grid>
                    )}

                    <Grid size={12}>
                        <LoadingButton
                            type="submit"
                            loading={isButtonLoading}
                            disabled={!isFormValid}
                        >
                            Reset password
                        </LoadingButton>
                    </Grid>

                    <Grid size={12} className="form-actions">
                        <LinkButton to="/sign-in">Already have an account? Sign in</LinkButton>
                    </Grid>
                </Grid>
            </Box>
        </BasePage>
    );
}